import React from 'react';
// @mui/material components
import { makeStyles } from '@mui/styles';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';

// material-ui icons
import Assignment from '@mui/icons-material/Assignment';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';

// core components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Table from 'components/Table/Table.js';

// style for this view

import { useDeleteRoleMutation, useGetRolesQuery } from 'api/role.api';
import styles from 'assets/jss/material-dashboard-pro-react/views/clientEditStyle.js';

const useStyles = makeStyles(styles);

export default function Roles(props) {
  const classes = useStyles();

  const { data: roles } = useGetRolesQuery();
  const [deleteCurrentRole] = useDeleteRoleMutation();

  const [deleteRole, setDeleteRole] = React.useState(false);
  const [currentRole, setCurrentRole] = React.useState(null);

  const handleEditRole = (index) => {
    props.history.push('/admin/role', { role: roles[index], new: false });
  };

  const handleDeleteRole = (index) => {
    setCurrentRole(roles[index]);
    setDeleteRole(true);
  };

  const deleteRoleConfirmed = () => {
    deleteCurrentRole(currentRole)
      .unwrap()
      .then(() => setDeleteRole(false));
  };

  const addRoleHandler = () => {
    props.history.push('/admin/role', { role: null, new: true });
  };

  const actionButton = (Icon, color, handler, key) => {
    return (
      <Button
        key={key}
        color={color}
        simple
        className={classes.actionButton}
        onClick={() => handler()}
      >
        <Icon className={classes.icon} />
      </Button>
    );
  };

  const roleList = () => {
    const listOfRoles = roles.map((role, key) => {
      var roleData = [];
      var actionButtons = [];
      roleData.push(role.name);
      roleData.push(role.description);
      actionButtons.push(
        actionButton(Edit, 'warning', () => handleEditRole(key), key)
      );
      actionButtons.push(
        actionButton(Delete, 'warning', () => handleDeleteRole(key), key + 1)
      );
      roleData.push(actionButtons);
      return roleData;
    });
    return listOfRoles;
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='rose'>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Store Roles</h4>
            <Button
              color='rose'
              onClick={addRoleHandler}
              className={classes.registerButton}
            >
              + Add Store Role
            </Button>
          </CardHeader>
          <CardBody>
            <Table
              tableHead={['Role', 'Description', 'Actions']}
              tableData={roleList()}
            />
          </CardBody>
        </Card>
      </GridItem>
      <Dialog
        open={deleteRole}
        onClose={() => setDeleteRole(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Delete {currentRole ? currentRole.name : ''}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Deleting this role cannot be undone!
            <br />
            Press Delete to confirm, or Cancel to cancel.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemedSecondaryBtn onClick={() => setDeleteRole(false)}>
            Cancel
          </ThemedSecondaryBtn>
          <ThemedPrimaryBtn
            onClick={() => deleteRoleConfirmed()}
            color='primary'
            autoFocus
          >
            Delete
          </ThemedPrimaryBtn>
        </DialogActions>
      </Dialog>
    </GridContainer>
  );
}
